import { cardApi } from "@/core/data/api";

export default async (values) => {
  return await cardApi.updateCard(values.id, values);
};
